import request from '@/utils/request'

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/macroscopic/industry/noAuth/boardList',
        method: 'get',
        params: query
    })
}

// 行业动态列表
export function industryList(query) {
    return request({
        url: '/macroscopic/industry/macroscopicList',
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/macroscopic/industry/${id}`,
        method: 'get',
    })
}

// 宏观数据(首页无权限)
export function macroscopicNoAuthList(query) {
    return request({
        url: '/macroscopic/metatron/macroscopic/noAuth/detailsList',
        method: 'get',
        params: query
    })
}


// 宏观数据
export function macroscopicList(query) {
    return request({
        url: '/macroscopic/metatron/macroscopic/detailsList',
        method: 'get',
        params: query
    })
}
